export class SimulateMultiResult {
	public Id: number;
	public Name: string;
	public SimulationsQuantity: number;
	public SimulationsCompletedQuantity: number;
	public StartTime: Date | number | string;
	public EndTime: Date | number | string;
	public CompletionTime: number | string;
	public UserId: number;
	public UserName: string;
	public Status: "Success" | "Canceled" | "Failure" | "In Progress";
}


export class OverviewFiltersInputDto {
	public SettingGroupId: number;
	public Action: string;
	public Filters: SelectStatementFilter[];
}

export class SelectStatementFilter {
	public Operation: number;
	public FieldName: string;
	public Value: string; 
}